<template>
  <div class="sider-all-box">
<!--    <div class="logo " />-->
    <div class="logo-box">
      <img src="../img/logoSingle.png" alt="" class="logo-text-box">
      <img src="../img/logoSingleText.png" alt="" class="" v-show="!collapsedVisible">
    </div>
    <a-menu theme="dark" mode="inline" :open-keys="openKeys"   @openChange="onOpenChange">

      <a-menu-item key="sub1" v-if="menuList.includes('大屏展示')||ismanager">
          <router-link to="/largerScreen/largerSiderPage">
          <a-icon type="fund" />
          <span>系统主页</span>
          </router-link>
      </a-menu-item>

      <a-sub-menu key="sub2" v-if="menuList.includes('设备管理')||ismanager">
        <span slot="title"><a-icon type="cluster" /><span>设备管理</span></span>

        <a-menu-item key="21">
          <router-link to="/equipment/senceList">场地展示</router-link>
        </a-menu-item>

        <a-menu-item key="22">
          <router-link to="/video/videoList">视频列表</router-link>
        </a-menu-item>

        <a-menu-item key="23">
          <router-link to="/equipment/equipmentList">设备列表</router-link>
        </a-menu-item>
 </a-sub-menu>

         <a-sub-menu key="sub3" v-if="menuList.includes('无人管理')||ismanager">
        <span slot="title"><a-icon type="yuque" /><span>无人装备</span></span>
         <a-menu-item key="31">
          <router-link to="/drivelessCar/drivelessCar">无人车</router-link>
        </a-menu-item>
         <a-menu-item key="32">
          <router-link to="/unmannedShip/unmannedShip">无人船</router-link>
        </a-menu-item>
         <a-menu-item key="33">
          <router-link to="/unmannedPlane/unmannedPlane">无人机</router-link>
        </a-menu-item>
         <a-menu-item key="34">
          <router-link to="/underwaterRobot/underwaterRobot">水下机器人</router-link>
        </a-menu-item>
      </a-sub-menu>

      <a-sub-menu key="sub4"  v-if="menuList.includes('生产管理')||ismanager">
        <span slot="title"><a-icon type="block" /><span>生产管理</span></span>

        <a-menu-item key="41">
          <router-link to="/productionManagement/scheduledTasks/scheduledTasksList">计划任务</router-link>
        </a-menu-item>

        <a-menu-item key="42">
          <router-link to="/productionManagement/clearPond/clearPondList">清塘管理</router-link>
        </a-menu-item>

        <a-menu-item key="43">
          <router-link to="/productionManagement/seeding/seedingList">投苗管理</router-link>
        </a-menu-item>

        <a-menu-item key="44">
          <router-link to="/productionManagement/patrolPond/patrolPondList">巡塘管理</router-link>
        </a-menu-item>

        <a-menu-item key="45">
          <router-link to="/productionManagement/feeding/feedingList">投喂管理</router-link>
        </a-menu-item>

        <a-menu-item key="46">
          <router-link to="/productionManagement/feedMedicine/feedMedicineList">施药管理</router-link>
        </a-menu-item>

        <a-menu-item key="47">
          <router-link to="/productionManagement/disease/diseaseList">病害管理</router-link>
        </a-menu-item>
      </a-sub-menu>

      <a-menu-item key="sub5" v-if="menuList.includes('精准投喂')||ismanager">
        <router-link to="/preciseFeeding/preciseFeedingList">
          <a-icon type="global" />
          <span>精准投喂</span>
        </router-link>
      </a-menu-item>

      <a-menu-item key="sub6"  v-if="menuList.includes('能耗分析')">
        <router-link to="/energyAnalysisList">
          <a-icon type="line-chart" />
          <span>能耗分析</span>
        </router-link>
      </a-menu-item>

      <a-sub-menu key="sub7" v-if="menuList.includes('渔技服务')||ismanager">
        <span slot="title"><a-icon type="radar-chart" /><span>渔技服务</span></span>

        <a-menu-item key="71">
          <router-link to="/fishServe/onlineExperts/onlineExpertsList">在线专家</router-link>
        </a-menu-item>

        <a-menu-item key="72">
          <router-link to="/fishServe/diseaseAnalysis/diseaseAnalysisList">疾病分析</router-link>
        </a-menu-item>

        <a-menu-item key="73">
          <router-link to="/fishServe/knowledgeQuery/knowledgeQueryList">知识查询</router-link>
        </a-menu-item>
      </a-sub-menu>



      <a-sub-menu key="sub8"  v-if="menuList.includes('项目管理')||ismanager">
        <span slot="title"><a-icon type="setting" /><span>项目管理</span></span>

        <a-menu-item key="85">
          <router-link to="/equipmentManagement/platformManagement/platformManagementList">项目管理</router-link>
        </a-menu-item>

        <a-menu-item key="81">
          <router-link to="/equipmentManagement/sceneManagement/sceneManagementList">场地管理</router-link>
        </a-menu-item>

        <a-menu-item key="82">
          <router-link to="/equipmentManagement/equipmentAllocation/equipmentAllocationList">设备分配</router-link>
        </a-menu-item>

        <a-menu-item key="83">
          <router-link to="/equipmentManagement/videoManagement/videoManagementList">视频管理</router-link>
        </a-menu-item>

        <a-menu-item key="84">
          <router-link to="/equipmentManagement/LEDManagement/ledManagementList">LED管理</router-link>
        </a-menu-item>
      </a-sub-menu>

      <a-sub-menu key="sub9"  v-if="menuList.includes('系统管理')||ismanager">
        <span slot="title"><a-icon type="menu" /><span>系统管理</span></span>

        <a-menu-item key="91">
          <router-link to="/systemManagement/basicInformation/basicInformationList">基础信息</router-link>
        </a-menu-item>

        <a-menu-item key="92">
          <router-link to="/systemManagement/log/logList">操作日志</router-link>
        </a-menu-item>

        <a-menu-item key="93">
          <router-link to="/systemManagement/user/userList">用户管理</router-link>
        </a-menu-item>

        <a-menu-item key="94">
          <router-link to="/systemManagement/propertyManagement/propertyList">权限管理</router-link>
        </a-menu-item>

        <a-menu-item key="95">
          <router-link to="/systemManagement/fishType/fishTypeList">种类管理</router-link>
        </a-menu-item>
      </a-sub-menu>

    </a-menu>

  </div>
</template>

<script>
  import { Component, Prop, Vue } from 'vue-property-decorator'


  export default {
    data() {
      return {
        rootSubmenuKeys: ['sub1','sub2', 'sub3', 'sub4', 'sub5','sub6', 'sub7', 'sub8'],
        openKeys: ['sub1'],
        menuList:[],
        ismanager:false
      };
    },
    props: {
      collapsedVisible: {
        type: Boolean
      },
    },
    mounted () {
      if (this.$store.getters.User.MenuList){
        this.menuList=this.$store.getters.User.MenuList;
      }
      if (this.$store.getters.User.cRoleName=="管理员"){
        this.ismanager=true;
      }




    },
    methods: {
      onOpenChange(openKeys) {
        const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);
        if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
          this.openKeys = openKeys;
        } else {
          this.openKeys = latestOpenKey ? [latestOpenKey] : [];
        }
      },


    },


  }
</script>

<style>
  .sider-all-box{
    min-height:100vh
  }

  .logo-box{
    margin: 20px 30px;
  }

  .logo-text-box{
    width: 25px;
    height: 30px;
    margin-right: 10px;
  }
</style>
